import { Link as RouterLink } from "react-router-dom";
import { Card, CardActionArea, CardHeader } from "@mui/material";

function ItemCard(props: { kind: string }) {
  return (
    <Card>
      <CardActionArea component={RouterLink} to={props.kind}>
        <CardHeader title={props.kind} />
      </CardActionArea>
    </Card>
  );
}

export default ItemCard;
